import { combineReducers } from 'redux';
import { resettableReducer } from 'reduxsauce';
import actionWatchReducer from 'redux-action-watch/lib/reducer';
import settings from './settings/reducer';
import menu from './menu/reducer';
import { ParticipantReducer } from './participant';
import { ParticipantsReducer } from './participants';
import { AssessmentsReducer } from './assessments';
import { EducationsReducer } from './educations';
import { ProviderReducer } from './provider';
import { UserReducer } from './user';
import { ExercisesReducer } from './exercises';
import { HepReducer, DrawerReducer } from './hep';
import { ProtocolsReducer } from './protocols';
import { RtmReducer } from './rtm';
import { DashboardsReducer } from './dashboards';
import { featureFlagsReducer } from './feature-flags';
import { outcomesFeatureFlagsReducer } from './outcomes-feature-flags';
import { NotesReducer } from './notes';

const resettable = resettableReducer('RESET');

export default combineReducers({
  menu,
  settings,
  participant: resettable(ParticipantReducer),
  participants: resettable(ParticipantsReducer),
  assessments: resettable(AssessmentsReducer),
  educations: resettable(EducationsReducer),
  provider: resettable(ProviderReducer),
  exercises: resettable(ExercisesReducer),
  user: UserReducer,
  hep: resettable(HepReducer),
  drawer: resettable(DrawerReducer),
  notes: resettable(NotesReducer),
  protocols: resettable(ProtocolsReducer),
  rtm: resettable(RtmReducer),
  dashboards: resettable(DashboardsReducer),
  featureFlags: resettable(featureFlagsReducer),
  outcomesFeatureFlags: resettable(outcomesFeatureFlagsReducer),
  // watcher - Must be last
  watcher: actionWatchReducer,
});
